export const DHL_FREE_LABELS_ANNOUNCEMENT_CUTOFF = Temporal.Instant.from(
  "2026-08-19T16:00:00Z",
);

export function isBeforeDhlFreeLabelsAnnouncementCutoff(
  now: Temporal.Instant,
): boolean {
  return Temporal.Instant.compare(now, DHL_FREE_LABELS_ANNOUNCEMENT_CUTOFF) < 0;
}
